import { Ref, RefNumber, RefDate } from "@tblabs/truffle";
import { BasketItemType } from "../../Models/Basket/BasketItemType";
import { DatesRange } from "../../Models/Dates/DatesRange";
import { Product } from "../../Models/Product/Product";
import { Basket } from "../../Services/Basket/Basket";
import { RentBasketItem } from "../../Services/Basket/RentBasketItem";
import { AddToBasketButton } from "./Components/AddToBasketButton";
import { Box } from "./Components/Box";
import { DatesRangeAndQuantityBox } from "./Components/DatesRangeBox";
import { DiscountBox } from "./Components/DiscountBox";
import { RentSummaryBox } from "./Components/RentSummaryBox";
import { ActionBox } from "./ActionBox";
import moment from "moment";


export class RentBox extends ActionBox
{
    constructor(product: Product, basket: Basket, productOptionId: Ref<string>)
    {
        super(basket);

        const quantityInBasket = basket.GetItemBy(BasketItemType.Rent, product.Id)?.Quantity?.value || 1;
        const quantity = new RefNumber(quantityInBasket);
        const startDate = new RefDate(moment().add(1, 'day').toDate()).Storable("rent-start-date");
        const endDate = new RefDate(moment().add(3, 'day').toDate()).Storable("rent-end-date");
        const datesRange = new DatesRange(startDate, endDate);

        const rentItem = new RentBasketItem(basket, product, productOptionId, quantity, datesRange);

        this.Append(
            new DatesRangeAndQuantityBox(datesRange, quantity),
            product.ShowDiscounts.value && new DiscountBox(basket, rentItem.FinalPriceBeforeDiscount),
            new Box("product__form-row product__form-row--summary", [
                new Box("product__summary-group", [
                    new RentSummaryBox(rentItem),
                ]),
            ]),
            new AddToBasketButton(() => this.TryAddToBasket(rentItem))
        );
    }
}
